export enum PROVIDER_TYPE {
	KVBO = 'KVBO',
	HCS = 'HCS',
	KVD = 'KVD',
	KTS = 'KTS',
	PORTMONE = 'PORTMONE',
	HOSTPAY = 'HOSTPAY',
	HOSTPAYMENT =  'HOSTPAYMENT',
}
